'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.init = init;
function init(_ref) {
  var el = _ref.el,
      context = _ref.context;

  var video = context.getElement('.' + context.className + '_Player');
  var trigger = context.getElement('.' + context.className + '_Controller');
  var playPauseButton = context.getElement('.' + context.className + '_Button');
  var playIcon = context.getElement('.' + context.className + '_PlayIcon');
  var pauseIcon = context.getElement('.' + context.className + '_PauseIcon');
  var seekBar = context.getElement('.' + context.className + '_Seekbar');

  if (typeof video !== 'undefined' && video != null) {
    video.load();
    trigger.onclick = function () {
      trigger.classList.add('vid-Video_Controller-hide');
      video.play();
    };

    playPauseButton.addEventListener('click', playPauseVideo);
    seekBar.addEventListener('change', setSeekBar);
    video.addEventListener('timeupdate', updateSeekBar);
    seekBar.addEventListener('mousedown', pauseVideo);
    seekBar.addEventListener('mouseup', playVideo);
  }

  function playPauseVideo() {
    if (video.paused === true) {
      video.play();
      playIcon.classList.add('vid-Controls_Icon-hide');
      pauseIcon.classList.remove('vid-Controls_Icon-hide');
    } else {
      video.pause();
      pauseIcon.classList.add('vid-Controls_Icon-hide');
      playIcon.classList.remove('vid-Controls_Icon-hide');
    }
  }

  function setSeekBar() {
    // Calculate the new time
    var time = video.duration * (seekBar.value / 100);

    // Update the video time
    video.currentTime = time;
  }

  function updateSeekBar() {
    // Calculate the slider value
    var value = 100 / video.duration * video.currentTime;

    // Update the slider value
    seekBar.value = value;
  }

  function pauseVideo() {
    video.pause();
  }

  function playVideo() {
    video.play();
  }
}